<template>
  <form @submit.prevent="filter">
    <!-- <base-select
      :service="$options.assetService"
      fetch-func="listCodes"
      label="Class"
      :horizontal="true"
      :small="true"
      :value.sync="filters.class"
    >
      <template v-slot:defaultOptionLabel>All</template>
    </base-select> -->
    <b-field label="Status" horizontal>
      <b-select size="is-small" expanded v-model="filters.status">
        <option value="all">All</option>
        <option value="valid">Valid</option>
        <option value="invalid">Invalid</option>
      </b-select>
    </b-field>
    <b-field label="Class" horizontal>
      <b-select v-model="filters.class" size="is-small" expanded :disabled="!contract">
        <option value>All</option>
        <option v-for="type in assetTypes" :value="type.id" :key="type.id">
          {{ type.name }}
        </option>
      </b-select>
    </b-field>
    <base-select
      :service="$options.assetService"
      fetch-func="listFiles"
      label="File"
      labelKey="filename"
      horizontal
      :small="true"
      :value.sync="filters.file"
    >
      <template v-slot:defaultOptionLabel>All</template>
    </base-select>
    <b-field label="Text/Number" horizontal>
      <b-input size="is-small" v-model="filters.keyword"></b-input>
    </b-field>
    <b-field label="Max. Assets" horizontal>
      <b-input size="is-small" v-model="filters.maxAssets"></b-input>
    </b-field>
    <b-field label="Scope (m)" horizontal>
      <b-input size="is-small" v-model="filters.proximity"></b-input>
    </b-field>
    <div class="columns">
      <div class="column is-6">
        <b-button
          class="is-fullwidth"
          :loading="exporting"
          :disabled="!filters.class && !filters.file"
          @click="exportList"
          size="is-small"
        >
          EXPORT
        </b-button>
      </div>
      <div class="column is-6">
        <b-button
          class="is-fullwidth"
          native-type="submit"
          type="is-link"
          size="is-small"
        >
          FILTER
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
import moment from "moment";
import BaseSelect from "@/components/partials/BaseSelect";
import { AssetService } from "@/services/asset.service";

export default {
  assetService: AssetService,
  props: {
    contract: {
      type: [String, Number]
    },
    assetTypes: {
      type: Array,
      default: () => []
    },
  },
  components: {
    BaseSelect
  },
  data: () => ({
    filters: {
      class: "",
      keyword: "",
      file: "",
      status: "valid",
      proximity: 300,
      maxAssets: 1000
    },
    exporting: false
  }),
  computed: {
    assetsMap() {
      return this.$store.state.AssetsMap;
    }
  },
  mounted() {
    // Set default value for proximity max assets filters (values from store)
    this.filters.proximity = this.assetsMap.maxRadius * 1000; // convert to m
    this.filters.maxAssets = this.assetsMap.maxAssets;
    this.filter();
  },
  methods: {
    fetchParams() {
      return {
        codeId: this.filters.class || undefined,
        keyword: this.filters.keyword || undefined,
        fileId: this.filters.file || undefined,
        status: this.filters.status || undefined,
        outerRad: this.filters.proximity || undefined,
        limit: this.filters.maxAssets || undefined,
      };
    },
    filter() {
      // Update store values
      this.$store.commit("AssetsMap/SET_STATE", {
        state: "maxRadius",
        value: this.filters.proximity / 1000 // convert to km
      });
      this.$store.commit("AssetsMap/SET_STATE", {
        state: "maxAssets",
        value: this.filters.maxAssets
      });

      this.$emit("filter", JSON.parse(JSON.stringify(this.fetchParams())));
    },
    async exportList() {
      this.exporting = true;

      try {
        const data = await this.$options.assetService.export(
          this.fetchParams(),
          { responseType: "blob" }
        );

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = `assets_${moment().format("MM-DD-YYYY")}.csv`;
        link.click();
      } catch (err) {}

      this.exporting = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapListFilters.vue